

import update from 'immutability-helper';
import { compose, withState, withProps, withHandlers, lifecycle } from 'recompose';

import isEqual from 'lodash/isEqual';

export const withSignatureModal = compose(
	withState('isOpen', 'setOpen', false),
	withHandlers({
		open: ({ setOpen }) => () => {
			setOpen(true);
		},
		close: ({ setOpen }) => () => {
			setOpen(false);
		},
		submit: ({ setOpen, saveSignatrues }) => () => {
			setOpen(false);
			saveSignatrues();
		},
	}),
);
